"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = require("@emotion/react");

var _svg = require("../../../components/icon/svg");

var _ = require("../../..");

var _Card = _interopRequireDefault(require("../svg/legacy/Card"));

var _Card2 = _interopRequireDefault(require("../svg/Card"));

var css = _interopRequireWildcard(require("./PaymentMethod.styles"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var PaymentMethod = function PaymentMethod(_ref) {
  var cardNumber = _ref.cardNumber,
      cvv = _ref.cvv,
      expiry = _ref.expiry,
      name = _ref.name,
      onCopyHandler = _ref.onCopyHandler;
  var theme = (0, _react.useTheme)();
  var isLegacy = theme.name === 'legacy';
  return (0, _jsxRuntime.jsxs)("div", {
    css: css.paymentMethod,
    children: [isLegacy ? (0, _jsxRuntime.jsx)(_Card["default"], {
      css: css.card
    }) : (0, _jsxRuntime.jsx)(_Card2["default"], {
      css: css.card
    }), (0, _jsxRuntime.jsx)("span", {
      css: css.cardNumber,
      children: cardNumber.match(/.{1,4}/g).join(' ')
    }), (0, _jsxRuntime.jsxs)("div", {
      css: css.expiryCvv,
      children: [(0, _jsxRuntime.jsx)("span", {
        css: css.expiry,
        children: expiry
      }), (0, _jsxRuntime.jsx)("span", {
        css: css.cvv,
        children: cvv
      })]
    }), (0, _jsxRuntime.jsx)("span", {
      css: css.fullName,
      children: name
    }), onCopyHandler && (0, _jsxRuntime.jsx)(_.Buttons.Primary, {
      css: css.copyButton,
      onClick: onCopyHandler,
      type: "button",
      children: (0, _jsxRuntime.jsx)(_svg.Copy, {
        fill: isLegacy ? theme.colors.white : theme.colors.muted,
        css: css.copyButtonIcon
      })
    })]
  });
};

var _default = PaymentMethod;
exports["default"] = _default;